import type { ReleasePage } from './releases.types'

import { sessionCache } from '@/utils/session-cache'

/** The last copy of each release this tab read, so a reload shows it at once while the fleet answers.
 *  Logout clears it (auth.store.ts). */
const cache = sessionCache<ReleasePage>('adx_release_last:', { maxChars: 1_500_000 })

export const readLastRelease = (name: string): ReleasePage | null => cache.read(name)

export const writeLastRelease = (page: ReleasePage): void => cache.write(page.version.name, page)

export const clearLastReleases = (): void => cache.clear()
